
import { BindWifiCardActions, BindWifiCardActionTypes } from '../actions/bind-wifi-card.actions';
import {WifiCardInfo, WifiList} from '../../../models/devices';

export interface State {
  wifiCardInfo: WifiCardInfo;
  wifiList: WifiList[];
  wifiCardStep: number;
  wifiListState: {
    Loading: boolean,
    Loaded: boolean
  };
  wifiCardState: {
    Loading: boolean,
    Loaded: boolean
  };
}

export const initialState: State = {
  wifiCardInfo: null,
  wifiList: [],
  wifiCardStep: 0,
  wifiListState: {
    Loaded: false,
    Loading: false
  },
  wifiCardState: {
    Loaded: false,
    Loading: false
  }
};

export function reducer(state = initialState, action: BindWifiCardActions): State {
  switch (action.type) {
    case BindWifiCardActionTypes.GetBindWifiCards:
      return {...state, wifiCardState: { Loaded: false, Loading: true }};

    case BindWifiCardActionTypes.LoadBindWifiCards:
      return {...state, wifiCardInfo: action.payload, wifiCardState: { Loaded: true, Loading: false }};

    case BindWifiCardActionTypes.GetBindWifiCardsFail:
      return {...state, wifiCardState: { Loaded: true, Loading: false }};

    case BindWifiCardActionTypes.GetWifiList:
      return {...state, wifiList: [], wifiListState: { Loaded: false, Loading: true }};

    case BindWifiCardActionTypes.LoadWifiList:
      return {...state, wifiList: action.payload , wifiListState: { Loaded: true, Loading: false }};

    case BindWifiCardActionTypes.GetWifiListFail:
      return {...state, wifiList: [], wifiListState: { Loaded: true, Loading: false}};

    case BindWifiCardActionTypes.ChangStepWifiCards:
      return {...state, wifiCardStep: action.payload};

    default:
      return state;
  }
}
